import { useState, useEffect } from 'react';

export const useDeviceType = () => {
  const [device, setDevice] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;

      setDevice({
        isMobile: width < 768, // Mobile: width < 768px
        isTablet: width >= 768 && width < 1024, // Tablet: 768px <= width < 1024px
        isDesktop: width >= 1024, // Desktop: width >= 1024px
      });
    };

    // Initial check
    updateDeviceType();

    // Add event listener for window resize
    window.addEventListener('resize', updateDeviceType);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateDeviceType);
    };
  }, []);

  return device;
};
